import { render } from "./HeroiconsSolidFilter.vue?vue&type=template&id=9c726118"
const script = {}

import exportComponent from "/www/yadonor/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidFilter.vue"]])

export default __exports__